/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ChargingDataDto } from '../../models/charging-data-dto';

export interface GetChargingDataListGet$Plain$Params {
  parkingPlaceId?: number;
}

export function getChargingDataListGet$Plain(http: HttpClient, rootUrl: string, params?: GetChargingDataListGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ChargingDataDto>>> {
  const rb = new RequestBuilder(rootUrl, getChargingDataListGet$Plain.PATH, 'get');
  if (params) {
    rb.query('parkingPlaceId', params.parkingPlaceId, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<ChargingDataDto>>;
    })
  );
}

getChargingDataListGet$Plain.PATH = '/GetChargingDataList';
